import { Link } from "react-router-dom";
import { Scale, BookOpen, Heart, Building2, Stethoscope, Shield } from "lucide-react";
import { useSeo } from "@/lib/seo";

const RESOURCES = [
  { Icon: Scale, title: "Legislation Tracker", desc: "State-by-state ownership laws and statute references.", to: "/legislation", internal: true },
  { Icon: BookOpen, title: "Owner's Education Hub", desc: "Guides on care, behavior, containment, and socialization.", to: "/information", internal: true },
  { Icon: Heart, title: "Rescue & Sanctuary Directory", desc: "Reputable rescues and sanctuaries that place and care for wolfdogs.", to: "/contact", internal: true },
  { Icon: Stethoscope, title: "Veterinary Resources", desc: "Finding wolfdog-friendly veterinary care and preventative health.", to: "/information", internal: true },
  { Icon: Building2, title: "Advocacy Organizations", desc: "Groups working toward balanced, science-based policy.", to: "/about", internal: true },
  { Icon: Shield, title: "Responsible Ownership Pledge", desc: "Best practices for being a positive ambassador for the community.", to: "/information", internal: true },
];

export default function Resources() {
  useSeo({ title: "Resources", description: "Trusted wolfdog resources, directories, and guides." });
  return (
    <div className="max-w-7xl mx-auto px-4 py-14">
      <p className="overline text-[#8B6D1F]">Toolkit</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight text-[#0A192F] mt-1">Resources</h1>
      <p className="mt-4 text-lg text-[#4A5568] max-w-2xl leading-relaxed">
        A curated collection of trusted resources for wolfdog owners, advocates, and the curious.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
        {RESOURCES.map(({ Icon, title, desc, to }) => (
          <Link key={title} to={to} className="group bg-white border border-[#0A192F]/10 p-7 hover:-translate-y-1 hover:border-[#D4AF37] transition-all">
            <div className="w-12 h-12 rounded-full bg-[#0A192F] flex items-center justify-center mb-4 group-hover:bg-[#D4AF37] transition-colors">
              <Icon className="w-5 h-5 text-[#D4AF37] group-hover:text-[#0A192F] transition-colors" />
            </div>
            <h3 className="font-display text-xl font-bold text-[#0A192F] group-hover:text-[#8B6D1F] transition-colors">{title}</h3>
            <p className="mt-2 text-sm text-[#4A5568] leading-relaxed">{desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
